import React from "react";
import { Modal, Button } from "@hid-galaxy-ui/galaxy-react";
import "./Modals.scss";

interface ValidationErrorModalProps {
  title: string;
  message: string;
  pendingCategories: string[];
  onClose: () => void;
}

const ValidationErrorModal: React.FC<ValidationErrorModalProps> = ({
  title,
  message,
  pendingCategories,
  onClose,
}) => {
  return (
    <Modal
      headerText={title}
      width={500}
      onClose={onClose}
      className="validation-error-modal"
    >
      <div className="modal-content">
        <p className="confirmation-message">{message}</p>
        {pendingCategories.length > 0 && (
          <div className="pending-categories-list">
            <ul>
              {pendingCategories.map((category, index) => (
                <li key={index}>{category}</li>
              ))}
            </ul>
          </div>
        )}
        <div className="modal-footer centered">
          <Button
            variant="primary"
            label="OK"
            normalCase={true}
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ValidationErrorModal;
